<div class="container">
    <tm1-card>
      <div class="card-container">
        <form id="editGate">
          <fieldset style="margin-bottom: 15px">
            <legend>Edit Gate</legend>
            <span>
              <tm1-text-field appearance="filled" inputsize="regular" label="Old Gate Name" labelposition=""
                helplabel="" value="{{ gateName }}" disabled=""></tm1-text-field>
            </span>

            <span>
              <tm1-text-field appearance="filled" inputsize="regular" label="New Gate Name" labelposition=""
                helplabel="" type="text" (change)="onGateNameChange($event)"></tm1-text-field>
            </span>


            <br />
            <tm1-button variant="solid" style="width: max-content" (click)="editGate()">
              Update
            </tm1-button>
          </fieldset>
        </form>
      </div>
    </tm1-card>
  </div>
